export enum CATEGORY_ACTION_TYPES {
  FETCH_ALL_DATA = "category/FETCH_ALL_DATA",
  UPDATE_CATEGORY = "category/UPDATE_CATEGORY",
  SET_DATA = "category/SET_DATA",
  SET_IS_LOADING = "category/SET_IS_LOADING",
}
